import React from 'react'
import {
  PageContext,
  Service,
  SEOMetadata,
  ContentGridItem
} from '../lib/sanity-types'
import { Layout } from './layout'
import {
  LineOverlay,
  Container,
  Box
} from '@sitewerk/juraholzbau-design-system'
import { Header } from './header-old'
import { RichText } from './rich-text'
import { Related } from './related'

export type DetailPageProps = {
  pageContext: PageContext
  related: ContentGridItem[]
  seo: SEOMetadata
  name: string
  description: any
  content: any
}

export const DetailPage: React.FC<DetailPageProps> = ({
  pageContext: { page, quotes, settings, menu },
  related,
  seo,
  name,
  description,
  content
}) => (
  <Layout seo={page.seo || seo} settings={settings} menu={menu}>
    <Header
      bgs={null}
      title={name}
      description={description}
      type="detail"
      menu={menu}
      quotes={quotes}
    />
    <LineOverlay bg="light" />
    <Container maxWidth="90ch">
      <Box ml="calc(3rem + 5vw)" mr={5} pb={[100, null, null, 150]}>
        <RichText blocks={content} />
      </Box>
    </Container>

    {related && related.length > 0 && <Related items={related} />}
  </Layout>
)
